<template>
    <div class="w-full h-full relative">
        <div class="flex items-end">
            <custom-input
                v-if="openInput"
                v-model="keyword"
                class="w-full min-w-0"
                :label="`Nueva ${label} (Separa por ',')`"
                :disabled="!enabled"
                @enter="addNewKeyword"
            />
            <custom-multiple-select
                v-else
                v-model="options"
                mode="search"
                :label="label"
                class="w-full min-w-0"
                :options="optionsSelectOptions"
                :disabled="!enabled"
                @change="onInput"
            />

            <app-button v-if="enabled" icon border @click="changeActionKeys">
                {{ openInput ? "✔️" : "➕" }}
            </app-button>
        </div>
    </div>
</template>

<script>
import CustomInput from "@/components/utils/CustomInput.vue";
import CustomMultipleSelect from "@/components/utils/CustomMultipleSelect.vue";

export default {
    name: "OptionsSelector",
    components: { CustomInput, CustomMultipleSelect },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        label: {
            type: String,
            default: () => "",
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        },
        base: {
            type: Array,
            default: () => [],
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        options: [],
        openInput: false,
        keyword: "",
        optionsBase: []
    }),
    computed: {
        optionsSelectOptions() {
            return this.optionsBase.map((item) => ({
                label: item,
                value: item
            }));
        }
    },
    watch: {
        itemsCurrent(value) {
            this.options = [...value];
        }
    },
    mounted() {
        const optionsBase = [...this.base, ...this.itemsCurrent];
        this.optionsBase = optionsBase.filter(
            (value, index, self) =>
                self.findIndex((item) => item === value) === index
        );
        this.options = this.itemsCurrent;
    },
    methods: {
        addNewKeyword() {
            const options = this.keyword.split(", ");
            for (const keyAux of options) {
                this.optionsBase.unshift(keyAux);
            }
            this.keyword = "";
            this.openInput = false;
        },
        changeActionKeys() {
            if (this.openInput) {
                this.addNewKeyword();
            } else {
                this.openInput = true;
            }
        },
        onInput(value) {
            this.$emit("change", value);
        }
    }
};
</script>
